// テーマのエントリポイント（defer で読み込まれる）
// 機能は src/js/ に分割し、[data-mp-*] 属性をフックにして動く。
import './scss/main.scss';
import { setupDrawers } from './js/drawer.js';
import { setupGnavSolid } from './js/gnav-solid.js';
import { setupJumps } from './js/jump.js';
import { setupAccordions } from './js/accordion.js';
import { setupModals } from './js/modal.js';
import { setupReveal } from './js/reveal.js';
import { setupHero } from './js/hero.js';
import { setupMessage } from './js/message.js';
import { setupParallax } from './js/parallax.js';
import { setupCarousels } from './js/carousel.js';
import { setupHashAlign } from './js/hash-align.js';
import { setupTabs } from './js/tabs.js';
import { setupLoopSliders } from './js/loop-slider.js';
import { setupSnapNavs } from './js/snap-nav.js';
import { setupStickyCtas } from './js/sticky-cta.js';
import { setupHashForward } from './js/hash-forward.js';

setupHashForward(); // 移動が要るときは他の初期化より先に
setupDrawers();
setupGnavSolid();
setupJumps();
setupAccordions();
setupModals();
setupReveal();
setupHero();
setupMessage();
setupParallax();
setupCarousels();
setupHashAlign();
setupTabs();
setupLoopSliders();
setupSnapNavs();
setupStickyCtas();
